module.exports = __webpack_public_path__ + "img/logo-lnf.761bbc9d.svg";